import styled from "styled-components";

export const InputTextField = styled.input`
  width: 100%;
  outline-color: ${(p) => (p.valid ? "black" : "red")};
`;
